import React, { useEffect, useState } from 'react';
import { ListItem, ListItemAvatar, ListItemText, Typography, List, FormControl, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import '../../../scss/pages/Rewards/SendRewards.scss';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import { REWARDS_HISTORY_PATH, REWARDS_PATH } from '../../../utils/Constants';
import { useNavigate, useLocation } from 'react-router';
import IncentiveRewards from '../../../asset/svg/IncentiveRewards.svg';
import StarRewards from '../../../asset/svg/StarRewards.svg';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/system';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from 'react-redux';
import RewardCoinLogo from '../../../asset/svg/RewardCoinLogo.svg';
import { SEND_REWARD_COINS, } from '../../../sagas/type';
import { useSnackbar } from 'notistack';
import selectCoinsStar from '../../../asset/svg/selectCoinsStar.svg';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


function SendRewards() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [userViewedData, setUserViewedData] = useState({ EmpName: '', EmpCode: '', Designation: '', Department: '', ReportingManager: '', balanceCoins: '', profileImage: '' },);
    const [open, setOpen] = useState(false);
    const [rewardCoins, setRewardCoins] = useState('')
    const [validateCoins, setvalidateCoins] = useState(false)
    const [rewardGroupsList, setRewardGroupList] = useState([])
    const [selectedReward, setSelectedReward] = useState({})
    const [rewardReason, setRewardReason] = useState('')
    const [loader, setLoader] = useState(false)


    useEffect(() => {
        console.log('location', location.state);
        if (location.state?.singleUserViewedData) {
            const { singleUserViewedData, spotRewardCoinsDetails } = location.state
            setUserViewedData((userViewedData) => ({ ...userViewedData, EmpName: singleUserViewedData.name, EmpCode: singleUserViewedData.code, Department: singleUserViewedData?.department, Designation: singleUserViewedData?.designation, ReportingManager: singleUserViewedData?.managerName, profileImage: singleUserViewedData.profileImage, balanceCoins: spotRewardCoinsDetails?.totalBalance }));
            setRewardGroupList(spotRewardCoinsDetails?.rewardGroupsList)
        }

    }, [location.state?.singleUserViewedData])

    useEffect(() => {
        console.log(Number(rewardCoins), selectedReward?.balance);
        if (Number(rewardCoins) > selectedReward?.balance) {
            setvalidateCoins(true)
        } else if (Number(rewardCoins) == selectedReward?.balance) {
            setvalidateCoins(false)
        }
        else {
            setvalidateCoins(false)
        }
    }, [rewardCoins, selectedReward])


    const handleBack = () => {
        navigate(REWARDS_PATH);
    }

    const handleCardClick = (data) => {
        setSelectedReward(data)
        setOpen(true)
    }

    const hanldeChange = (value) => {
        setRewardCoins(value)
    }

    const navigateSendNow = () => {
        sendRewardCoins()
        setLoader(true)
    }

    const sendRewardCoins = () => {
        const { managerCode, singleUserViewedData, } = location?.state;
        const { code, department } = singleUserViewedData
        dispatch({
            type: SEND_REWARD_COINS,
            payload: {
                managerCode: managerCode, rewardGroupId: selectedReward?.id, subordinateCode: code, department: department, amount: Number(rewardCoins), reasonForReward: rewardReason,
            },
            navigate: navigate, userViewedData: userViewedData, rewardCoins: rewardCoins, enqueueSnackbar: enqueueSnackbar, setOpen: setOpen, setLoader: setLoader
        })
    }

    const handleCloseModal = () => {
        setvalidateCoins(false)
        setRewardCoins('')
        setRewardReason('')
        setOpen(false)
    }

    const hanldeRewardReasonChange = (value, name) => {
        setRewardReason(value)
    }

    const { singleUserViewedData, managerCode, spotRewardCoinsDetails } = location?.state;
    const handleOpenHistory = () => {
        navigate(REWARDS_HISTORY_PATH, { state: { singleUserViewedData: singleUserViewedData, managerCode: managerCode, spotRewardCoinsDetail: spotRewardCoinsDetails, isRoute: "isSendRewards" } })
    }

    return (
        <div className='sendRewardsContainer'>
            <div className='sendRewardsContainer_header'>
                <div>
                    <img className='sendRewardsContainer_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;&nbsp;
                    <span className='sendRewardsContainer_header_header1'>Give Rewards</span>
                </div>
                <div>
                    {/* <img className='rewardsContainer_header_rewardCoinsLogo' src={RewardCoinLogo} alt="" />&nbsp;&nbsp;
                    <span className='rewardsContainer_header_rewardCoins'>{userViewedData?.balanceCoins}</span> */}
                    <Typography sx={{ color: "#8074FF", fontWeight: 700, fontSize: "14px", fontFamily: " 'Noto Sans', sans-serif", textAlign: "right", lineHeight: "20px" }} onClick={handleOpenHistory}>History</Typography>
                </div>
            </div>
            <div className='sendRewardsContainer_userContainer'>
                <List sx={{ width: "100%", maxWidth: 360, padding: 0 }}>
                    <ListItem alignItems="flex-start" >
                        <ListItemAvatar> <img style={{ width: '36px' }} src={userViewedData.profileImage} alt="" /> </ListItemAvatar>
                        <ListItemText sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px' }}
                            primary={userViewedData?.EmpName}
                            secondary={
                                <div sx={{ color: 'white' }}>
                                    <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '12px', lineHeight: '12px', color: 'rgba(255,255,255,0.5)' }} component="span" variant="body2" color="white">{userViewedData?.EmpCode}</Typography>
                                </div>
                            }
                        />
                    </ListItem>
                </List>

                <div className='sendRewardsContainer_userContainer_userDatas'>
                    <div className='sendRewardsContainer_userContainer_userDatas_position'>
                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Designation</Typography>
                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{userViewedData?.Designation}</Typography>
                    </div>
                    <div className='sendRewardsContainer_userContainer_userDatas_position'>
                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Department</Typography>
                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{userViewedData?.Department}</Typography>
                    </div>
                    <div className='sendRewardsContainer_userContainer_userDatas_position'>
                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Reporting Manager</Typography>
                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{userViewedData?.ReportingManager}</Typography>
                    </div>
                </div>
            </div>

            <div className='sendRewardsContainer_typeheading'>
                <Typography sx={{ fontStyle: 'normal', fontWeight: 500, fontSize: '16px', lineHeight: '16px', color: '#FFFFFF' }}>Select Rewards</Typography>
            </div>

            {rewardGroupsList && rewardGroupsList.length > 0 && rewardGroupsList.map((data, index) => {
                return (
                    <div className='sendRewardsContainer_imageContainer' onClick={() => handleCardClick(data)}>
                        {index % 2 == 0 ? <div className='sendRewardsContainer_imageContainer_RewardParent' >
                            <img className='sendRewardsContainer_imageContainer_RewardParent_Image' src={StarRewards} alt="" />
                            <Typography className='sendRewardsContainer_imageContainer_RewardParent_Content'>{data.name}</Typography>
                        </div> :
                            <div className='sendRewardsContainer_imageContainer_RewardParent'>
                                <img className='sendRewardsContainer_imageContainer_RewardParent_Image' src={IncentiveRewards} alt="" />
                                <Typography className='sendRewardsContainer_imageContainer_RewardParent_Content'>{data.name}</Typography>
                            </div>}
                    </div>
                )
            })
            }
            <Modal open={open} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'auto' }} >
                <div className='sendRewardsContainer_modalContainer'>
                    <div className='sendRewardsContainer_modalContainer_closeButton' >
                        <IconButton aria-label="close" sx={{ color: '#FFFFFF' }} onClick={handleCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <Box sx={{ backgroundColor: '#0B245F;', borderRadius: '2rem' }}>
                        <div className='sendRewardsContainer_modalContainer_box1'>
                            <Box sx={{ background: 'linear-gradient(180deg, rgba(45, 85, 180, 0.9) 0%, rgba(45, 85, 180, 0) 90.86%);', borderTopLeftRadius: '2rem', borderTopRightRadius: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', width: '300px', }}>
                                <img className='sendRewardsContainer_modalContainer_box1_selectCoinsStarImg' src={selectCoinsStar} alt='' />
                                <div >
                                    <Typography sx={{ color: "#FFFFFF", fontStyle: 'normal', fontWeight: 600, fontSize: '18px', lineHeight: '16px', padding: '1rem', textAlign: 'center' }}>{selectedReward?.name}</Typography>
                                    <Typography sx={{ color: "#FFFFFF", fontStyle: 'normal', fontWeight: 400, fontSize: '14px', lineHeight: '12px', padding: '0px 1rem 1rem 1rem', textAlign: 'center' }}>Balance
                                        &nbsp;&nbsp;  <img style={{ width: '12px' }} src={RewardCoinLogo} alt="" />&nbsp;&nbsp;
                                        <span style={{ fontSize: '16px', fontWeight: '700', lineHeight: '14px', color: '#E4F450' }}>{selectedReward?.balance}</span></Typography>
                                </div>
                            </Box>
                        </div>
                        <div className='sendRewardsContainer_modalContainer_box2'>
                            <Box sx={{ backgroundColor: '#0B245F;', borderBottomLeftRadius: '2rem', borderBottomRightRadius: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', width: '300px', }}>
                                <div className='sendRewardsContainer_modalContainer_box2_header'>
                                    <Typography sx={{ color: "#FFFFFF", fontStyle: 'normal', fontWeight: 700, fontSize: '16px', lineHeight: '16px', padding: '1rem 1rem 1rem 0rem' }}>Select Coins</Typography>
                                </div>
                                <div className='sendRewardsContainer_modalContainer_box2_radioConatiner'>
                                    <FormControl >
                                        <RadioGroup aria-labelledby="demo-radio-buttons-group-label" defaultValue="" name="" >
                                            {selectedReward && selectedReward?.denominations && selectedReward?.denominations.length && selectedReward?.denominations.map((value) => {
                                                return (
                                                    <FormControlLabel onChange={(event) => hanldeChange(event.target.value)} sx={{ m: 1, width: 280, fontSize: '16px', lineHeight: '16px', fontWeight: 700, color: '#E4F450;', background: 'linear-gradient(92.6deg, rgba(255, 255, 255, 0) 4.88%, rgba(255, 255, 255, 0.2) 52.39%, rgba(255, 255, 255, 0) 80.32%), rgba(255, 255, 255, 0.1);', borderRadius: '12px', padding: '6px', }} value={value} control={<Radio style={{ color: 'white' }} />} label={value} />
                                                )
                                            })}
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <div className='sendRewardsContainer_modalContainer_box2_header'>
                                    <Typography sx={{ color: "#FFFFFF", fontStyle: 'normal', fontWeight: 700, fontSize: '16px', lineHeight: '16px', padding: '1rem 1rem 1rem 0rem' }}>Reason for Reward</Typography>
                                </div>
                                <div>
                                    <FormControl sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#FFFFFF", }, m: 1, width: 280, backgroundColor: 'rgba(255,255,255,0.1)', color: 'red', borderRadius: '12px' }}>
                                        <TextField fullWidth multiline InputProps={{ rows: 3, }} InputLabelProps={{ style: { color: 'gray' }, }} value={rewardReason ? rewardReason : ''} name='Reason'
                                            placeholder='Type Here'
                                            onChange={(event) => hanldeRewardReasonChange(event.target.value, event.target.name)}
                                        />
                                    </FormControl>
                                </div>
                                {validateCoins && <div className='sendRewardsContainer_modalContainer_box2_errorContainer'>
                                    <Typography fontStyle='normal' fontWeight='600' fontSize='11px' lineHeight='10px' alignItems='center' color='#F95F5F;' textAlign='center'> You don't have enough balance</Typography>
                                </div>}
                                <div className='sendRewardsContainer_modalContainer_box2_sendNowbuttonContainer'>
                                    <button disabled={validateCoins || rewardCoins?.length <= 0 || !validateCoins && rewardCoins?.length <= 0 || validateCoins && rewardCoins?.length <= 0 || rewardReason?.length <= 0} className={`${!validateCoins && rewardCoins?.length > 0 && rewardReason?.length > 0 ? 'sendRewardsContainer_modalContainer_box2_sendNowbuttonContainer_sendNowbutton' : 'sendRewardsContainer_modalContainer_box2_sendNowbuttonContainer_sendNowdisablebutton'}`} onClick={navigateSendNow}>Send Now</button>
                                </div>
                            </Box>
                        </div>
                    </Box>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={loader}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </div>
            </Modal >
        </div >
    )
}

export default SendRewards;